// Page chunks that are also loaded ahead of time from elsewhere.
// The chat page: the sign-in page starts downloading it while the user types,
// since signing in lands on /chat.
export const loadChat = () => import("../modules/chatai/container/UnifiedChat");
